/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForJiraServiceManagementParent extends models.ServiceAccountNativeDetailsBaseForJiraServiceManagement {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForJiraServiceManagementParent");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForJiraServiceManagementParent.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForJiraServiceManagementParent>): ServiceAccountNativeDetailsForJiraServiceManagementParent {
        let obj = Object.assign(new ServiceAccountNativeDetailsForJiraServiceManagementParent(), model);
        ServiceAccountNativeDetailsForJiraServiceManagementParent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForJiraServiceManagementParent>): ServiceAccountNativeDetailsForJiraServiceManagementParent {
        if (!model) return null;
        return ServiceAccountNativeDetailsForJiraServiceManagementParent.newInstance(<ServiceAccountNativeDetailsForJiraServiceManagementParent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForJiraServiceManagementParent) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForJiraServiceManagementParent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForJiraServiceManagementParent): boolean {
        if (models.ServiceAccountNativeDetailsBaseForJiraServiceManagement.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForJiraServiceManagementParent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
